import React, { useState, useEffect, useCallback } from 'react';
import './FlussoApprovativo.scss';
import axios from 'axios';
import appInfo from '../../app-info';
import notify from 'devextreme/ui/notify';

import Toolbar from 'devextreme-react/toolbar';
import { useAuth } from '../../contexts/auth';
import { AccordionForm } from '../../components';
import ScrollView from 'devextreme-react/scroll-view';
import Button from 'devextreme-react/button';
import MultiView, { Item } from 'devextreme-react/multi-view';
import { TextArea } from 'devextreme-react/text-area';
import ValidationGroup from 'devextreme-react/validation-group';

import { custom } from 'devextreme/ui/dialog';

import {
    Validator,
    CustomRule
} from 'devextreme-react/validator';

const url = appInfo.urlWebApi;


export default function App() {
    const { user } = useAuth();
    const [selectedIndex, setSelectIndex] = useState(0);
    const [selectText, setSelectText] = useState({ selectedTitolo: '', selectedCorpo: '', doValidation: false, selectedStatus: null });
    const [isEditable, setEditable] = useState(true);
    const [annotazione, setAnnotazione] = useState('');
    const [titolo, setTitolo] = useState({});
    const [flussoApprovativo, SetFlusso] = useState('');
    const [isDisable, SetDisable] = useState(false);

    const getAxiosInstance = useCallback((timeout = 3000) => axios.create({
        baseURL: url,
        timeout,
        headers: { 'X-Custom-Header': 'foobar' }
    }), []);

    useEffect(() => {
        if (user) {
            (async () => {
                await DataSourceRiepilogo();
                await CheckFlussoApprovativo();
            })();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function DataSourceRiepilogo() {
        const queryParameters = new URLSearchParams(window.location.search);
        const prev = queryParameters.get("d");
        const flux = queryParameters.get("e");

        if (!user) return;

        try {
            const instance = getAxiosInstance();
            const response = await instance.get('/api/FlussiApprovativi/GetDati', {
                params: { internalKey: user.internalKey, idPreventivo: prev, idFlussoApprovativo: flux }
            });
            setTitolo(response.data);
        } catch (error) {
            notify('Errore nel caricamento dei dati', 'error');
        }
    }

    async function CheckFlussoApprovativo() {
        const queryParameters = new URLSearchParams(window.location.search);
        const prev = queryParameters.get("d");
        const flux = queryParameters.get("e");

        if (!user) return;

        try {
            const instance = getAxiosInstance();
            const response = await instance.get('/api/FlussiApprovativi/CheckFlussoApprovativo', {
                params: { internalKey: user.internalKey, idPreventivo: prev, idFlussoApprovativo: flux, idUtente: user.id }
            });
            const result = response.data;

            if (result === 16) SetFlusso('RIFIUTATO');
            else if (result === 8) SetFlusso('ANNULLATO');
            else if (result === 20) SetFlusso('APPROVATO');

            setEditable(result === 0);
        } catch (error) {
            notify('Errore nel controllo del flusso', 'error');
        }
    }

    async function GetDocumento() {
        const queryParameters = new URLSearchParams(window.location.search);
        const prev = queryParameters.get("d");

        if (!user) return;

        try {
            const instance = getAxiosInstance(50000);
            const response = await instance.get('/api/FlussiApprovativi/DownloadFile', {
                params: { internalKey: user.internalKey, idPreventivo: prev }
            });
            const bytes = base64ToArrayBuffer(response.data.dataObject);
            const urlBlob = window.URL.createObjectURL(new Blob([bytes]));
            const link = document.createElement('a');

            link.href = urlBlob;
            link.setAttribute('download', response.data.fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            notify('Errore nel download del documento', 'error');
        }
    }


    const SetFlussoApprovativo = useCallback(async () => {
        const queryParameters = new URLSearchParams(window.location.search);
        const prev = queryParameters.get("d");
        const flux = queryParameters.get("e");

        if (!user) return 0;

        console.log(flux);

        try {
            SetDisable(true);
            const instance = getAxiosInstance(50000);
            const response = await instance.get('/api/FlussiApprovativi/SetFlussoApprovativo', {
                params: {
                    internalKey: user.internalKey,
                    idPreventivo: prev,
                    idUtente: user.id,
                    nota: annotazione,
                    status: selectText.selectedStatus, 
                    idFlussoApprovativo: flux
                }
            });
            return response.data;
        } catch (error) {
            notify('Errore durante il cambio stato', 'error');
            return 0;
        } finally {
            SetDisable(false);
        }
    }, [user, annotazione, selectText.selectedStatus, getAxiosInstance]);

    function goToBackIndex() {
        setSelectIndex(prev => Math.max(prev - 1, 0));
    }

    function goToForwardIndex(e) {
        const index = selectedIndex + 1;
        if (index === 1) {
            switch (e.element.id) {
                case 'btnAccetta':
                    setSelectText({
                        selectedTitolo: 'PREVENTIVO ACCETTATO',
                        selectedCorpo: 'Il preventivo passa al successivo step approvativo previsto.',
                        doValidation: false,
                        selectedStatus: 20
                    });
                    break;
                case 'btnRifiuta':
                    setSelectText({
                        selectedTitolo: 'PREVENTIVO RIFIUTATO',
                        selectedCorpo: 'Il preventivo viene riportato all\'attenzione del compilatore e retrocesso in stato "In compilazione"',
                        doValidation: true,
                        selectedStatus: 16
                    });
                    break;
                case 'btnAnnulla':
                    setSelectText({
                        selectedTitolo: 'PREVENTIVO ANNULLATO',
                        selectedCorpo: 'Il preventivo viene annullato definitivamente.',
                        doValidation: true,
                        selectedStatus: 8
                    });
                    break;
                default:
            }
        }
        setSelectIndex(index);
    }

    function customValidation(params) {
        if (selectText.doValidation) {
            return params.value && params.value.trim().length > 0;
        }
        return true;
    }

    function GetTitolo() {
        return 'Preventivo - ' + (titolo.CODICE || '') + ' Rev. ' + (titolo.REVISIONE || '');
    }

    function base64ToArrayBuffer(base64) {
        const binaryString = atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    const validate = useCallback(async (params) => {
        const result = params.validationGroup.validate();
        if (result.isValid) {
            const returnValue = await SetFlussoApprovativo();
            if (returnValue === 1 || returnValue === 2) {
                setSelectIndex(2);
            } else {
                let customDeleteConfirmDialog = custom({
                    showTitle: false,
                    messageHtml: "Errore durante il cambio stato...",
                    buttons: [{
                        text: "Ok",
                        onClick: () => true
                    }]
                });
                customDeleteConfirmDialog.show();
            }
        }
    }, [SetFlussoApprovativo, setSelectIndex]);

    const handleAnnotazioneChange = useCallback((e) => {
        setAnnotazione(e.value);
    }, []);

    const downloadButtonOptions = {
        icon: 'download',
        text: 'Download preventivo in formato excel',
        onClick: async () => {
            await notify('Download in corso!');
            await GetDocumento();
            await notify('Download completato!');
        },
    };

    return (
        <React.Fragment>
            <h2 className={'content-block'}>{GetTitolo()}</h2>
            <div className={'dx-card responsive-paddings full-background'}>
                <ScrollView width='100%' height='100%'>
                    <div className={'right-padding-r'}>
                        <MultiView
                            animationEnabled={true}
                            loop={false}
                            swipeEnabled={false}
                            selectedIndex={selectedIndex}>
                            <Item>
                                <Toolbar>
                                    <Item location="after" locateInMenu="auto" widget="dxButton" options={downloadButtonOptions}/>
                                </Toolbar>
                                <div>
                                    <AccordionForm user={user} collapsible={true} selectedIndex={0} />
                                </div>
                                {isEditable ? (
                                    <div>
                                        <div>
                                            <div>
                                                <Button id='btnAccetta' type="success" icon="check" width={'100%'} text='ACCETTA' onClick={goToForwardIndex}></Button>
                                            </div>
                                            <div>
                                                <Button id='btnRifiuta' type="danger" icon="remove" width={'100%'} text='RIFIUTA' onClick={goToForwardIndex}></Button>
                                            </div>
                                            <div>
                                                <Button id='btnAnnulla' type="normal" icon="clearsquare" width={'100%'} text='ANNULLA' onClick={goToForwardIndex}></Button>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='text-onlyedit'>
                                        <p>Il flusso approvativo attuale è già stato visionato ed è in stato: <span>{flussoApprovativo}</span> </p>
                                    </div>
                                )}
                            </Item>
                            <Item>
                                <ValidationGroup>
                                    <p><b>{selectText.selectedTitolo}</b></p>
                                    <p>{selectText.selectedCorpo}</p>
                                    <TextArea value={annotazione} onValueChanged={handleAnnotazioneChange}>
                                        <Validator>
                                            <CustomRule
                                                type="custom"
                                                message={"Annotazione obbligatoria"}
                                                reevaluate={true}
                                                validationCallback={customValidation}/>
                                        </Validator>
                                    </TextArea>
                                    {isEditable ? (
                                        <div>
                                            <Button id='btnValida' disabled={isDisable} type="success" icon="check" width={'100%'} text='OK' onClick={validate}></Button>
                                        </div>
                                    ) : null}
                                    <div>
                                        <Button id='btnCancella' disabled={isDisable} type="danger" icon="revert" width={'100%'} text='CANCELLA' onClick={goToBackIndex}></Button>
                                    </div>
                                </ValidationGroup>
                            </Item>
                            <Item>
                                <div className='text-onlyedit'>
                                    <p>Attività completata</p>
                                </div>
                            </Item>
                        </MultiView>
                    </div>
                </ScrollView>
            </div>
        </React.Fragment>
    );
}







